// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"layout_wrapper__ZqPXY","container":"layout_container__8mgcn","pane":"layout_pane__R5fnn"};